import Vue from "vue";
import { controlsHelper }  from "@/components/mixins/commonControlsHelper"

export default Vue.extend({
    name: "WysiwygHtmlArea",
    mixins: [controlsHelper],
    props: {
        html: {
            type: String,
            default: ""
        }
    },
    data: () => ({
        downloads: [],
        cleanedHtml: ""
    }),
    mounted(){
        this.cleanedHtml = this.html;
        this.setDownloads();
        this.removeDownloadsFromHtml();
    },
    watch: {
        html: function() {
            this.setDownloads();
            this.removeDownloadsFromHtml();
        }
      },
    methods: {
        //get downloads from news story - to be rendered at bottom
        setDownloads() {
            const parser = new DOMParser();
            const doc = parser.parseFromString(this.html, 'text/html');
            const anchors = doc.querySelectorAll('a[class^="news-story__download-"]');
            this.downloads = Array.from(anchors).map(anchor => {
                const className = anchor.className;
                const fileType = className.split('news-story__download-')[1];
                const fileName = anchor.textContent.trim();
                const fileLink = anchor.href;
                return { fileType, fileName, fileLink };
            });           
        },

        //remove downloads from news story
        removeDownloadsFromHtml(){
            const parser = new DOMParser();
            const cleanedDoc = parser.parseFromString(this.html, 'text/html');
            const anchorsToRemove = cleanedDoc.querySelectorAll('a[class^="news-story__download-"]');
            anchorsToRemove.forEach(anchor => anchor.remove());
            this.cleanedHtml = cleanedDoc.body.innerHTML;
        },

        handleWysiwygClick(event: any) {
            var anchorTag : any = "";
            if (event.target.tagName === "A") {
                anchorTag = event.target;
            }
            else{
                anchorTag = event.target.closest("a");
            }
            if(!anchorTag){
                return;
            }
            var targetIsBlank = (anchorTag.target === "_blank")

            if (anchorTag.tagName === "A") {
                var lowercaseHref = anchorTag.href.toLowerCase();
                if (lowercaseHref.includes("partdetail")) {
                    var hrefSplit = lowercaseHref.split("oempartcode=");
                    if (hrefSplit && hrefSplit.length >= 1) {
                        var oemPartCode = hrefSplit[1];
                        event.preventDefault();

                        // If target not set to blank - continue with routing logic as intended.
                        if (!targetIsBlank){
                            this.$router.push({ name: 'PartDetails', query: { oemPartCode: oemPartCode.toUpperCase() } })
                        }
                        // Otherwise open in a new tab.
                        else {
                            let routeData = this.$router.resolve({ name: 'PartDetails', query: { oemPartCode: oemPartCode.toUpperCase() } });
                            window.open(routeData.href, '_blank');
                        }
                    }
                }
                else if (lowercaseHref.includes("docs/msds.aspx")) {
                    var hrefSplit = lowercaseHref.split("part=");
                    if (hrefSplit && hrefSplit.length >= 1) {
                        var oemPartCode = hrefSplit[1];
                        event.preventDefault();
                        var url = `${window.appGlobals.PART_IMAGES_API_URL}Media/GetMsds/${oemPartCode.toUpperCase()}`
                        window.open(url, '_blank');
                    }

                }
                else if (anchorTag.origin === location.origin && 
                    anchorTag.pathname.startsWith("/") 
                    && !anchorTag.pathname.startsWith("/~/") 
                    && !anchorTag.pathname.includes("aspx")) {
                    event.preventDefault();
                    var slug = anchorTag.pathname + anchorTag.search;

                    // If target not set to blank - continue with routing logic as intended.
                    if(!targetIsBlank){
                        this.$router.push(slug);
                    }
                    // Otherwise open in a new tab.
                    else {
                        window.open(this.$router.resolve(slug).href, '_blank');
                    }
                    
                }
                else{
                    
                }
            }
        }
    }
});
